/**
 * Base Tokenizer Class — Re-exported from @lokascript/framework
 *
 * Abstract base class for language-specific tokenizers.
 * Provides keyword management, morphological normalization,
 * and high-level token extraction methods.
 */

export { BaseTokenizer } from '@lokascript/framework';
export type { KeywordEntry, TokenizerProfile } from '@lokascript/framework';
